class PreventMultipleSubmit {
	constructor(config) {
		this.config = Object.assign({
			scope: '.prevent-multiple-submit'
		}, config);

		this.init();
	}

	init() {
		$(document).off('.prevent-multiple-submit')
			.on('submit.prevent-multiple-submit', this.config.scope, this.disableButtons.bind(this))
	}

	disableButtons(event) {
		let $form = $(event.currentTarget);

		$form.find('button', (index, button) => {
			$(button).attr('disabled', true);
		});

		if(! $form.attr('id')) {
			return true;
		}

		$(`button[form="${$form.attr('id')}"]`).each((index, button) => {
			$(button).attr('disabled', true);
		})

		return true;
	}
}

export default PreventMultipleSubmit;